<template>
	<div class="base-aside">
		<!-- <el-menu class="el-menu-vertical-demo" background-color="#fff" :default-active="$store.state.activateMenu" text-color="#666" active-text-color="#345ACF" router>
			<el-menu-item index="/mainIndex" v-if="isWorker==true">
			  <i class="el-icon-s-home" style="color: #3ea563"></i>
			  <span slot="title" style="font-weight: bold;color: #3ea563">首页</span>
			</el-menu-item>
			<el-submenu v-for="(menu, index) in menuData" :key="index" :index="index+''" v-if="menuIds.indexOf(menu.id) > -1 ">
				<template slot="title">
					<i :class="[menu.icon]" style="color: #3ea563"></i>
					<span style="font-weight: bold;color: #3ea563">{{ menu.name }}</span>
				</template>

				<el-menu-item
					v-for="(item, i) in menu.children"
					v-if="menuIds.indexOf(item.id) > -1 "
					:key="index + '-' + i"
					:index="item.url"
					@click="clickMenu(item)"
				>
					<span>{{ item.name }}</span>
				</el-menu-item>
			</el-submenu>
		</el-menu> -->
		<ul class="menu" v-show="!$store.state.user.isSJGS">
			<li class="item" :class="$store.state.activateMenuUrl==item.url?'active':''" v-for="(item, i) in menuData" :key="item.id" v-if="menuIds.indexOf(item.id) > -1 " @click="clickMenu(item.url)">
				<i class="iconfont icon" :class="item.icon"></i>
				<i class="point" v-for="item2 in approveCountList" v-if="item2.id == item.id && item2.num > 0">{{item2.num}}</i>
				<div class="title">{{item.name}}</div>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'base-aside',
	props: {
	  approveCountList: {
	    type: Array
	 }
	},
	data() {
		return {
			menuData:[],
			isCollapse: false,
			menuIds:[],
			isWorker:true,
		};
	},
	created() {
		this.initMenu()
	},
	methods: {
		// 初始化菜单数据
		initMenu(id){
			let isWorker = JSON.parse(localStorage.getItem('isWorker'))
			let {menuData,menuData2} = require('@/utils/menuData')
			let menuID
			if(id){
				menuID=id
			}else{
				menuID =this.$store.state.activateMenu
			}
			let m = ""
			if(isWorker) {
				m = menuData.find(x => x.id == menuID)
			}else {
				m = menuData2.find(x => x.id == menuID)
			}


			
			this.menuIds = JSON.parse(localStorage.getItem('user')).menuIds
			if(m){
				this.menuData = m.children
			}else{
				this.menuData = []
			}

			
			
			// if(isWorker==true){
			// 	this.isWorker = true
			// 	this.menuData = menuData
			// }else{
			// 	this.isWorker = false
			// 	this.menuData = menuData2
			// }		
		},
		// 点击菜单
		clickMenu(url) {
			//通过vuex将数据存储在store中
			this.currentUrl = url
			this.$router.push(url);
		}
	}
};
</script>
<style lang="less" scoped>
.base-aside {
	width: auto;
	height: calc( 100% - 15px);
	// position: absolute;
	// top:60px;
	.menu {
		background-color:#fff;
		color:#666;
		width: 100px;
		height: calc( 100% - 15px);
		padding: 0;
		margin: 0;
		.item{
			list-style: none;
			text-align: center;
			margin: 10px 0;
			cursor: pointer;
			padding:10px 0;
			position: relative;
			&:hover {
			background: #f3f4f8 !important;
		}
			.icon {
				font-size: 36px;
				color: #3ea563;;
			}
			.title {
				color:#3ea563;
				padding-top: 10px;
				font-size: 14px;
			}
			.point {
				position: absolute;
				// width: 20px;
				// height: 20px;
				// border: 1px solid #ff0000;
				// border-radius: 50%;
				// text-align: center;
				// line-height: 20px;
				// top: 0px;
				// right:2px;
				// color: #ff0000;
				// font-weight: bold;
				
				top: 0px;
				right:2px;
				background-color: #f56c6c;
				border-radius: 10px;
				color: #fff;
				display: inline-block;
				font-size: 12px;
				height: 18px;
				line-height: 18px;
				padding: 0 6px;
				text-align: center;
				white-space: nowrap;
				border: 1px solid #fff;
			}
		}
	}
	.active {
		font-size: bold;
		background: #f3f4f8;
		position: relative;
		border-left: 4px solid #67c23a;
		// &::before {
		// 	position: absolute;
		// 	left: 0;
		// 	width: 3px;
		// 	height: 100%;
		// 	background: #67c23a !important;
		// 	content: '';
		// 	display: inline-block;
		// }
	}

	/deep/.el-menu-vertical-demo {
		height: 100%;
		border: none;

		&:not(.el-menu--collapse) {
			width: 200px;
			height: 100%;
			overflow: auto;
		}

		li {
			width: 100%;
		}

		.menu-title {
			color: #666;
		}

		.el-submenu__title:hover {
			background: #eaeefa !important;
		}

		.el-menu-item.is-active {
			background: #eaeefa !important;
			color: #67c23a!important;
		}

		.el-menu-item.is-active::before {
			position: absolute;
			left: 0;
			width: 3px;
			height: 100%;
			background: #67c23a !important;
			content: '';
			display: inline-block;
		}

		.el-menu-item:hover {
			background: #eaeefa !important;
			color: #67c23a !important;
		}

		//当侧边栏收起时的样式
		.el-menu--popup-right-start {
			.el-menu-item:hover {
				width: 100%;
			}

			.is-active {
				width: 100%;
				background: #eaeefa !important;
			}
		}
	}
	.menu-title {
		color: #666;
	}

	.el-menu-item.is-active {
		background: #eaeefa !important;
	}
	/deep/.el-menu-item.is-active::before {
		position: absolute;
		left: 0;
		width: 3px;
		height: 100%;
		background: #345acf !important;
		content: '';
		display: inline-block;
	}
	.el-menu-item:hover {
		background: #eaeefa !important;
		color: #345acf !important;
	}
	/deep/.el-submenu__title:hover {
		background: #eaeefa !important;
	}
	//当侧边栏收起时的样式
	.el-menu--popup-right-start .el-menu-item:hover {
		width: 100%;
	}
	.el-menu--popup-right-start .is-active {
		width: 100%;
		background: #eaeefa !important;
	}

	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 200px;
		height: 100%;
		overflow: auto;
	}
}
</style>
